import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/user-profile.svg";
var UserProfileOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  UserProfileOutline_default as default
};
